import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContentReport, ReportsResponse } from '../helpers/interface';

export type { ContentReport, ReportsResponse } from '../helpers/interface';

@Injectable({ providedIn: 'root' })
export class ContentReportService {
  private http: HttpClient = inject(HttpClient);

  /**
   * Fetches the available report reasons from the server.
   */
  getReasons(): Observable<string[]> {
    return this.http.get<string[]>('/api/reports/reasons');
  }

  /**
   * Fetches all content reports, optionally filtered by status or type.
   */
  getReports(options?: {
    status?: string;
    type?: string;
    limit?: number;
    offset?: number;
  }): Observable<ReportsResponse> {
    let params = new HttpParams();
    if (options?.status) params = params.set('status', options.status);
    if (options?.type) params = params.set('type', options.type);
    if (options?.limit) params = params.set('limit', options.limit.toString());
    if (options?.offset) params = params.set('offset', options.offset.toString());
    return this.http.get<ReportsResponse>('/api/reports', { params });
  }

  /**
   * Updates the status of a report (reviewed or dismissed).
   */
  reviewReport(reportId: number, status: 'reviewed' | 'dismissed'): Observable<ContentReport> {
    return this.http.put<ContentReport>(`/api/reports/${reportId}`, { status });
  }

  /**
   * Submits a content report for a post.
   */
  reportPost(postId: number, reason: string, details?: string): Observable<any> {
    return this.http.post('/api/reports', {
      post_id: postId,
      reason,
      details: details || null,
    });
  }

  /**
   * Submits a content report for a comment.
   */
  reportComment(commentId: number, reason: string, details?: string): Observable<any> {
    return this.http.post('/api/reports/comment', {
      comment_id: commentId,
      reason,
      details: details || null,
    });
  }
}
